// extracted by mini-css-extract-plugin
export var opportunities = "opportunities-module--opportunities--oF2zp";
export var opportunities__title = "opportunities-module--opportunities__title--A56Jv";
export var opportunities__desc = "opportunities-module--opportunities__desc--cz0Y9";
export var opportunities__item = "opportunities-module--opportunities__item--BD-YE";
export var opportunities__itemTitle = "opportunities-module--opportunities__itemTitle--y2dYn";
export var opportunities__itemContent = "opportunities-module--opportunities__itemContent--l-KXi";
export var opportunities__itemDesc = "opportunities-module--opportunities__itemDesc--4gcNr";
export var opportunities__itemLink = "opportunities-module--opportunities__itemLink--bHqn2";
export var opportunities__itemButton = "opportunities-module--opportunities__itemButton--iULv3";
export var opportunities__item_active = "opportunities-module--opportunities__item_active--G40Hh";